import { isPlatform } from "@ionic/react";

export function setItem(key:string,value:string){
    if(isPlatform("desktop")){
        window.sessionStorage.setItem(key,value);
    }else{
        window.localStorage.setItem(key,value)
    }
}

export function removeItem(key:string){
    if(isPlatform("desktop")){
        window.sessionStorage.removeItem(key);
    }else{
        window.localStorage.setItremoveItemem(key)
    }
}

export function getItem(key:string){
    if(isPlatform("desktop")){
        return window.sessionStorage.getItem(key);
    }else{
        return window.localStorage.getItem(key)
    }
}